import SinglePicker from "./SinglePicker"
import axios from "axios"

import { useRef } from "react"
import { useQuery } from "react-query"
import { betterFetch } from "utils/apis"

const fetchAndMapCustomers = async (url: string) => {
  const { data } = await axios.get(url)
  const items = data.results.map((item: any) => ({
    value: item.id,
    label: item.customer_name,
    data: item,
  }))
  return items
}

const CustomerPicker = (props: {
  showLabel?: boolean
  pageSize?: number
  shouldAddDefault?: boolean
  label?: string
  labelClass?: string
  placeholder?: string
  selected?: number
  isClearable?: boolean
  errorText?: string
  flush?: boolean
  onSelect?: (item: any) => void
}) => {
  const items = useRef<any>({})
  const selected = props.selected
  // const selected = 11

  const { data: customer } = useQuery(
    ["customer", selected],
    betterFetch(`customers/${selected}`),
    {
      cacheTime: 10000,
      refetchOnWindowFocus: false,
      enabled: !!selected && !props.label,
    }
  )

  const loadOptions = async (inputValue: string, callback: any) => {
    const url = `/customers/lite?page=1&page_size=${
      props.pageSize ?? 200
    }&ordering=company_name&company_name=${
      encodeURIComponent(inputValue) ?? ""
    }`

    const value = inputValue ?? "all"

    if (items?.current?.[value]) {
      return items?.current?.[value]
    }

    // if (!inputValue) {
    items.current[value] = await fetchAndMapCustomers(url)
    if (props.shouldAddDefault)
      items.current[value] = [{ label: "Default", shouldClear: true }].concat(
        items.current[value]
      )

    return items.current[value]
    // }

    // clearTimeout(timer)

    // return new Promise((resolve) => {
    //   timer = setTimeout(async () => {
    //     const data = await fetchAndMapCustomers(url)
    //     resolve(data)
    //   }, 400)
    // })
  }

  return (
    <SinglePicker
      errorText={props.errorText}
      async
      pageSize={200}
      className="min-w-[200px] max-w-[200px]"
      loadOptionsFunction={loadOptions}
      isClearable={props.isClearable}
      flush={props.flush}
      labelClass={props.labelClass}
      label={props.showLabel ? props.label ?? "Customer" : ""}
      endpoint="customers/lite?page=1&ordering=company_name"
      placeholder={props.placeholder ?? "Choose Customer"}
      getLabel={(customer: { customer_name: string }) =>
        customer?.customer_name
      }
      selected={props.selected}
      onSelect={props.onSelect}
      defaultSelection={
        selected
          ? {
              value: customer?.id ?? props.selected,
              label: props.label ?? customer?.company_name,
            }
          : null
      }
    />
  )
}

export default CustomerPicker
